import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import includes from 'lodash/includes';
import classNames from 'classnames';
import { Container } from 'reactstrap';

import env from 'Env';
import store from 'Redux/store';
import FluidImg from 'Components/Utility/FluidImg';
import imgixConfig from 'Config/imgix';
import StripBanner from 'Components/Banner/StripBanner';
import useViewport from 'Hooks/useViewport';
import CountdownTimer from 'Components/Utility/CountdownTimer';

const logClick = (url, appearsOn) => {
  if (appearsOn === 'home') {
    store.dispatch({
      type: 'frontend/click/CLICK_INTERACTION',
      payload: { section: 'MainCarousel', value: url, context: 'TakeOver' },
    });
  }
};

const renderVideoTakeOver = (videoSrc, url, appearsOn) => {
  const internalLink = includes(url, 'www.fanatical.com');

  if (!url) {
    return (
      <div className="hero-background-container hero-video-container">
        <video
          loop
          autoPlay
          muted
          playsInline
          className="hero-background hero-video"
        >
          <source src={videoSrc} type="video/mp4" />
        </video>
      </div>
    );
  }

  if (!internalLink) {
    return (
      <a
        className="hero-background-container hero-video-container"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => logClick(url, appearsOn)}
      >
        <video
          loop
          autoPlay
          muted
          playsInline
          className="hero-background hero-video"
        >
          <source src={videoSrc} type="video/mp4" />
        </video>
      </a>
    );
  }

  return (
    <Link
      to={`/${url.split('/en/')[1]}`}
      className="hero-background-container hero-video-container"
      onClick={() => logClick(url, appearsOn)}
    >
      <video
        loop
        autoPlay
        muted
        playsInline
        className="hero-background hero-video"
      >
        <source src={videoSrc} type="video/mp4" />
      </video>
    </Link>
  );
};

const renderBackground = (bgImgSrc, takeOverBannerName, url, appearsOn) => {
  const internalLink = includes(url, 'www.fanatical.com');
  const srcSet = `
    ${bgImgSrc}?${imgixConfig}&w=5000&h=400&fit=crop 5000w,
    ${bgImgSrc}?${imgixConfig}&w=4250&h=340&fit=crop 4250w,
    ${bgImgSrc}?${imgixConfig}&w=3600&h=285&fit=crop 3600w,
    ${bgImgSrc}?${imgixConfig}&w=2500&h=200&fit=crop 2500w,
    ${bgImgSrc}?${imgixConfig}&w=1800&h=200&fit=crop 1800w,
    ${bgImgSrc}?${imgixConfig}&w=1520&h=179&fit=crop 1520w,
    ${bgImgSrc}?${imgixConfig}&w=1200&h=143&fit=crop 1200w,
    ${bgImgSrc}?${imgixConfig}&w=992&h=107&fit=crop 992w,
    ${bgImgSrc}?${imgixConfig}&w=768&h=79&fit=crop 768w
                `;

  if (!url) {
    return (
      <div className="hero-background-container">
        <img
          srcSet={srcSet}
          sizes="100vw"
          src={`${bgImgSrc}?${imgixConfig}&w=1800&h=200&fit=crop`}
          alt={takeOverBannerName}
          className="hero-background"
        />
      </div>
    );
  }

  if (!internalLink) {
    return (
      <a
        className="hero-background-container"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => logClick(url, appearsOn)}
      >
        <img
          srcSet={srcSet}
          sizes="100vw"
          src={`${bgImgSrc}?${imgixConfig}&w=1800&h=200&fit=crop`}
          alt={takeOverBannerName}
          className="hero-background"
        />
      </a>
    );
  }

  return (
    <Link
      to={`/${url.split('/en/')[1]}`}
      className="hero-background-container"
      onClick={() => logClick(url, appearsOn)}
    >
      <img
        srcSet={srcSet}
        sizes="100vw"
        src={`${bgImgSrc}?${imgixConfig}&w=1800&h=200&fit=crop`}
        alt={takeOverBannerName}
        className="hero-background"
      />
    </Link>
  );
};

const renderBanner = (
  imageObj,
  url,
  name,
  dealsLive,
  showDealsButton,
  countdownHasStarted,
  countdownEnd,
  appearsOn,
) => {
  let internalLink = false;
  if (includes(url, 'www.fanatical.com')) internalLink = true;

  const image = (
    <FluidImg
      src={imageObj.img}
      alt={imageObj.alt ? imageObj.alt : name}
      className="center-img hero-front"
      overrideWidth="100"
      subfolder="original"
      folder="product"
      lazy={false}
    />
  );

  if (!url) {
    return (
      <React.Fragment>
        {showDealsButton &&
          <div className={classNames('takeover-deals-container', { 'takeover-deals-container--home': showDealsButton === 'homepage' }, { 'takeover-deals-container--onsale': showDealsButton === 'onsalepage' })}>
            {!countdownHasStarted &&
              <div className="takeover-deals-button">
                Deals Live Now: <span>{dealsLive}</span>
              </div>
            }
            {countdownHasStarted &&
              <div className="takeover-deals-button">
                <FormattedMessage
                  id="takeover.button.ends-in"
                  defaultMessage="Sale Ends In: {timer}"
                  values={{
                    timer: <CountdownTimer showZero value={Date.parse(countdownEnd)} />,
                  }}
                />
              </div>
            }
          </div>
        }
        {image}
      </React.Fragment>
    );
  }

  if (!internalLink) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" onClick={() => logClick(url, appearsOn)}>
        {showDealsButton &&
          <div className={classNames('takeover-deals-container', { 'takeover-deals-container--home': showDealsButton === 'homepage' }, { 'takeover-deals-container--onsale': showDealsButton === 'onsalepage' })}>
            {!countdownHasStarted &&
              <div className="takeover-deals-button">
                Deals Live Now: <span>{dealsLive}</span>
              </div>
            }
            {countdownHasStarted &&
              <div className="takeover-deals-button">
                <FormattedMessage
                  id="takeover.button.ends-in"
                  defaultMessage="Sale Ends In: {timer}"
                  values={{
                    timer: <CountdownTimer showZero value={Date.parse(countdownEnd)} />,
                  }}
                />
              </div>
            }
          </div>
        }
        {image}
      </a>
    );
  }

  return (
    <Link to={`/${url.split('/en/')[1]}`} onClick={() => logClick(url, appearsOn)}>
      {showDealsButton &&
        <div className={classNames('takeover-deals-container', { 'takeover-deals-container--home': showDealsButton === 'homepage' }, { 'takeover-deals-container--onsale': showDealsButton === 'onsalepage' })}>
          {!countdownHasStarted &&
            <div className="takeover-deals-button">
              Deals Live Now: <span>{dealsLive}</span>
            </div>
          }
          {countdownHasStarted &&
            <div className="takeover-deals-button">
              <FormattedMessage
                id="takeover.button.ends-in"
                defaultMessage="Sale Ends In: {timer}"
                values={{
                  timer: <CountdownTimer showZero value={Date.parse(countdownEnd)} />,
                }}
              />
            </div>
          }
        </div>
      }
      {image}
    </Link>
  );
};

const TakeOver = ({
  adverts,
  appearsOn,
  mobileOverride,
  siteBrand,
  previewTakeOver,
  dealsLive,
}) => {
  let { isAboveSm, isBelowMd } = useViewport();
  const hasLoaded = adverts.hasLoaded;
  if (mobileOverride) isAboveSm = false;
  if (mobileOverride) isBelowMd = true;

  const AllTakeOverBanners = get(adverts, 'TakeOver', []);
  let takeOverBanner = get(adverts, 'TakeOver', []).filter(banner => !banner.partnerBrand).find(ad => get(ad, `appears_on[${appearsOn}]`));

  // Check preload script content to decide whether to display empty element before all call loads
  // topBackgroundSolid is takeOverBackground
  // topBanner is takeOverForeground
  // topBannerMobile is takeOverMobile
  if (!hasLoaded) {
    if (window.appearsOn && window.appearsOn.replace(/[-_]/g, '').toLowerCase() === appearsOn.replace(/[-_]/g, '').toLowerCase()) {
      if (isAboveSm) {
        if (window.topBackgroundSolid) {
          return <React.Fragment><div className="solid-hero-container" /><StripBanner banner={takeOverBanner} appearsOn={appearsOn} /></React.Fragment>;
        }
        if (window.topBanner) {
          return <Container><div className="centre-image-container" /></Container>;
        }
      } else if (isBelowMd) {
        if (window.topBannerMobile) {
          return <React.Fragment><div className="mobile-takeover center-img-container" /><StripBanner banner={takeOverBanner} appearsOn={appearsOn} /></React.Fragment>;
        }
      }
    }
  }

  if (previewTakeOver) takeOverBanner = previewTakeOver;

  // If there is a takeover with partnerBrand set, this will be the chosen takeover
  if (siteBrand && siteBrand !== 'fanatical' && !previewTakeOver) {
    AllTakeOverBanners.forEach((banner) => {
      if (banner.appears_on[appearsOn] && banner.partnerBrand === siteBrand) {
        takeOverBanner = banner;
      }
    });
  }

  if (isEmpty(takeOverBanner)) return false;

  const takeOverBannerName = get(takeOverBanner, 'name', '');
  const takeOverBannerUrl = get(takeOverBanner, 'url', '');
  const takeOverBannerImages = get(takeOverBanner, 'images', []);
  const takeOverBannerVideos = get(takeOverBanner, 'videos', []);
  const takeOverBackground = takeOverBannerImages.find(img => img.img_type === 'take_over_background');
  const takeOverForeground = takeOverBannerImages.find(img => img.img_type === 'take_over_foreground');
  const takeOverMobile = takeOverBannerImages.find(img => img.img_type === 'take_over_mobile');
  const takeOverBackgroundVideo = takeOverBannerVideos.find(video => video.video_type === 'take_over_background_video');
  const takeOverMobileVideo = takeOverBannerVideos.find(video => video.video_type === 'take_over_mobile_video');

  const backgroundVideoSrc = !isEmpty(takeOverBackgroundVideo) ? `${env.videoCdnUrl}${takeOverBackgroundVideo.video}` : '';
  const mobileVideoSrc = !isEmpty(takeOverMobileVideo) ? `${env.videoCdnUrl}${takeOverMobileVideo.video}` : '';

  const includeStripBanner = get(takeOverBanner, 'include_strip_banner', false);

  let showDealsButton = null;
  if (dealsLive && appearsOn === 'home' && takeOverBannerName.toLowerCase().includes('red hot')) showDealsButton = 'homepage';
  if (dealsLive && appearsOn === 'on_sale' && takeOverBannerName.toLowerCase().includes('red hot')) showDealsButton = 'onsalepage';

  const countdownStart = '2024-07-10T15:00:00.000Z';
  const countdownEnd = '2024-07-11T15:00:00.000Z';
  let countdownHasStarted = false;
  if (Date.now() > Date.parse(countdownStart) && Date.now() < Date.parse(countdownEnd)) {
    countdownHasStarted = true;
  }

  if (isAboveSm) {
    if (takeOverBackground) {
      const bgSrc = get(takeOverBackground, 'img', '');
      let bgImgSrc = `${env.cdnUrl}/product/original/${bgSrc}`;

      const splitSrc = bgSrc.split('.');
      if (splitSrc && splitSrc.length && splitSrc[splitSrc.length - 1] === 'gif') {
        bgImgSrc = `${env.srcCdnUrl}/product/original/${bgSrc}`;
      }

      return (
        <React.Fragment>
          <header className="solid-hero-container">
            {takeOverForeground &&
              <Container className="solid-center-img-container">
                {renderBanner(
                  takeOverForeground,
                  takeOverBannerUrl,
                  takeOverBannerName,
                  dealsLive,
                  showDealsButton,
                  countdownHasStarted,
                  countdownEnd,
                  appearsOn,
                )}
              </Container>
            }

            {!!backgroundVideoSrc
              && renderVideoTakeOver(backgroundVideoSrc, takeOverBannerUrl, appearsOn)
            }

            {renderBackground(bgImgSrc, takeOverBannerName, takeOverBannerUrl, appearsOn)}

          </header>

          {includeStripBanner && <StripBanner banner={takeOverBanner} appearsOn={appearsOn} />}

        </React.Fragment>
      );
    }

    if (takeOverForeground) {
      return (
        <Container>
          <div className="center-img-container">
            {renderBanner(
              takeOverForeground,
              takeOverBannerUrl,
              takeOverBannerName,
              dealsLive,
              showDealsButton,
              countdownHasStarted,
              countdownEnd,
              appearsOn,
            )}
          </div>
        </Container>
      );
    }
  }

  if (isBelowMd && takeOverMobile) {
    return (
      <React.Fragment>
        <div className="mobile-takeover center-img-container">
          {renderBanner(
            takeOverMobile,
            takeOverBannerUrl,
            takeOverBannerName,
            dealsLive,
            showDealsButton,
            countdownHasStarted,
            countdownEnd,
            appearsOn,
          )}
          {!!mobileVideoSrc &&
            <div className="mobile-video-takeover">
              <video
                loop
                autoPlay
                muted
                playsInline
              >
                <source src={mobileVideoSrc} type="video/mp4" />
              </video>
            </div>
          }
        </div>
        {includeStripBanner && <StripBanner banner={takeOverBanner} />}
      </React.Fragment>
    );
  }

  return false;
};

TakeOver.propTypes = {
  adverts: PropTypes.shape({}),
  appearsOn: PropTypes.oneOf([
    'home',
    'bundles',
    'on_sale',
    'latest_deals',
    'new_releases',
    'ending_soon',
    'coming_soon',
    'gift_guide',
    'flash_deals',
    'all_games',
    'black_friday',
    'cyber_monday',
    'full_price_games',
    'fantasyverse',
    'mystery',
  ]).isRequired,
  mobileOverride: PropTypes.bool,
  siteBrand: PropTypes.string,
  previewTakeOver: PropTypes.bool,
};

TakeOver.defaultProps = {
  adverts: {},
  mobileOverride: false,
  siteBrand: 'fanatical',
  previewTakeOver: false,
};

const mapStateToProps = ({
  adverts,
  siteBrand,
  sales: { dealsLive },
}) => ({
  adverts,
  siteBrand,
  dealsLive,
});

const areEqual = (prevProps, nextProps) => {
  const prevAdverts = prevProps.adverts;
  const nextAdverts = nextProps.adverts;

  return !isEmpty(prevAdverts) && !isEmpty(nextAdverts) &&
    !isEmpty(prevAdverts.TakeOver) && !isEmpty(nextAdverts.TakeOver) &&
    prevAdverts.TakeOver[0].url === nextAdverts.TakeOver[0].url;
};

export default connect(mapStateToProps)(React.memo(TakeOver, areEqual));
